import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import NProgress from "nprogress"
import 'nprogress/nprogress.css'
import store from "@/store"; //这个样式必须引入

Vue.use(NProgress)
Vue.use(VueRouter)

const router = new VueRouter({
    scrollBehavior: () => ({y: 0}),
    // mode: 'history',
    // base:'/h5/',
    routes,
})

router.beforeEach((to, from, next) => {

   // console.log(to.fullPath)
//     if (to.fullPath.indexOf('/admin') >= 0 && to.fullPath.indexOf('/login') < 0) {
//         // NProgress.start()
//     window.localStorage.setItem('token',result.data.token);
    if(to.fullPath === '/login'){
        next();
    }else {
        let token = window.localStorage.getItem("token");
        if (token && token.length > 0) {
            next()
        } else {
            next({path:'/login'})
            // this.$router.replace('/login');
        }
    }

//
//     } else {
//         next()
//     }
//     next()
})

router.afterEach(() => {
    // window.scrollTo(0,0);
    NProgress.done();
})

export default router
